'use client';

import { Crown } from 'lucide-react';
import { cn } from '@/lib/utils';

interface IconBadgeProps {
  className?: string;
}

export function IconBadge({ className }: IconBadgeProps) {
  return (
    <span
      title="Icon Player"
      className={cn(
        'inline-flex text-amber-400 transition-colors hover:text-amber-500',
        className
      )}
    >
      <Crown className="h-4 w-4" />
    </span>
  );
}
